/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import PropTypes from 'prop-types'
import cls from 'classnames'

const RateTableDisclosureButton = ({
  testid = 'rate-table-disclosure-button',
  open,
  onClick,
  isMobile = false,
  className = '',
}) => {
  return (
    <div className={className}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <p
        data-testid={testid}
        className={cls('neutral500', isMobile ? 'disclaimer' : 'bodySmall')}
        onClick={onClick}
      >
        Disclosure <i className={`cred-icon ${open ? 'icon-chevron-up' : 'icon-chevron-down'}`} />
      </p>
    </div>
  )
}

RateTableDisclosureButton.propTypes = {
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  testid: PropTypes.string,
}

export default RateTableDisclosureButton
